module.exports = __webpack_public_path__ + "static/media/Diskriminere.d5f0096d.m4a";